import { noop } from 'lodash'
import React from 'react'
import { Form, FormControlProps } from 'react-bootstrap'

interface TTextArea
  extends Pick<
    FormControlProps,
    | 'bsCustomPrefix'
    | 'htmlSize'
    | 'size'
    | 'plaintext'
    | 'readOnly'
    | 'disabled'
    | 'value'
    | 'onChange'
    | 'custom'
    | 'type'
    | 'id'
    | 'isValid'
    | 'isInvalid'
    | 'className'
    | 'as'
  > {
  rows?: number
  style?: any
  placeholder?: string
}

const Textarea = (props: TTextArea): React.ReactElement => {
  const {
    rows = 3,
    bsCustomPrefix,
    htmlSize,
    size,
    plaintext = false,
    readOnly = false,
    disabled = false,
    value,
    onChange = noop,
    custom = false,
    type,
    id,
    isValid = false,
    isInvalid = false,
    className = '',
    as = 'textarea',
    style,
    placeholder,
  } = props

  return (
    <Form.Control
      as={as}
      rows={rows}
      bsCustomPrefix={bsCustomPrefix}
      htmlSize={htmlSize}
      size={size}
      plaintext={plaintext}
      readOnly={readOnly}
      disabled={disabled}
      value={value}
      onChange={onChange}
      custom={custom}
      type={type}
      id={id}
      isValid={isValid}
      isInvalid={isInvalid}
      className={className}
      style={style}
      placeholder={placeholder}
    />
  )
}

export default Textarea
